import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import defaultAvatar from './static/default-avatar.svg';

import TopStatus from './TopStatus';
import BottomStatus from './BottomStatus';

import { createAvatar } from '@dicebear/core';
import { openPeeps } from '@dicebear/collection';



function getInitials(name, size) {
  if (name.startsWith('+')) { // this if for the grouped compoenent
    return name;
  }

  const words = name.trim().split(' ');
  if (['lg', 'xl', 'xxl', 'huge'].includes(size)) {
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase() + words[0].charAt(0).toUpperCase();
    }
    return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
  } else if (['xs', 'sm', 'md'].includes(size)) {
    return words[0].charAt(0).toUpperCase();
  } else {
    return '';
  }
}

function Avatar({
  alt,
  size,
  src,
  variant,
  type,
  topStatus,
  bottomStatus,
  userName,
  className,
  border,
  dicebeerConfig,
  ...others
}) {
  const dicebear = createAvatar(openPeeps, {
    seed: userName,
    ...dicebeerConfig,
  });

  return (
    <div className={classNames("pgn__avatar", `avatar-wrapper-${size}`, className, border && `avatar-wrapper-border-${size}`)}>

      <div className={classNames("avatar-wrapper", `avatar-wrapper-${size}`, `avatar-wrapper-${variant}`)}>
        {type == "image" && <img className={classNames("avatar-img-section-userImage")} src={src} alt={alt} />}
        {type == "dicebeer" && <img className={classNames("avatar-img-section-avatar-icon")} src={dicebear.toDataUri()} alt={alt} />}
        {type == "letters" && <div className={classNames(`avatar-label-${variant}`, "avatar-img-section-letters")}>{getInitials(userName, size)}</div>}

        {topStatus && <TopStatus topStatus={topStatus} size={size} />}
        {bottomStatus && <BottomStatus bottomStatus={bottomStatus} size={size} />}
      </div>
    </div>

  );
}

Avatar.propTypes = {
  /** Alt text. Usually the user's name */
  alt: PropTypes.string,
  /** Size of the avatar */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'huge']).isRequired,
  /** Image src of the avatar image */
  src: PropTypes.string,
  /** className that can be passed to the parent */
  className: PropTypes.string,
  /** avatarName is the name of the person of the avatar, this is used to generate the dicebeer icon and and letters shown in the icon */
  userName: PropTypes.string.isRequired,
  /** background color of the Avatar */
  variant: PropTypes.oneOf(['blue', 'orange', 'red', 'green', 'yellow', 'purple', 'sky', 'pink', 'teal', "white"]).isRequired,
  /** Type of the Avatar */
  type: PropTypes.oneOf(['letters', 'image', 'dicebeer']).isRequired,
  /** Top status of the Avatar */
  topStatus: PropTypes.oneOf(['verified', 'pin', 'favorite', 'add', 'remove', 'notification']),
  /** Bottom status of the Avatar */
  bottomStatus: PropTypes.oneOf(['online', 'offline', 'busy', 'away', 'company']),
  /** Border of the Avatar */
  dicebeerConfig: PropTypes.object,
};

Avatar.defaultProps = {
  alt: '',
  size: 'md',
  src: undefined,
  className: '',
  userName: '',
  variant: 'blue',
  topStatus: undefined,
  bottomStatus: undefined,
  type: 'default',
  dicebeerConfig: {},
};

export default Avatar;
